// extracted by mini-css-extract-plugin
export default {"text":"RandomSpeech_text__6aFsI","first_pp":"RandomSpeech_first_pp__BX1zQ","second_pp":"RandomSpeech_second_pp__nCIJa"};